module.exports = __webpack_public_path__ + "edb151e0ac0331918655ac5a0ec4fbe2.jpg";